import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useClientSideDPSellerIdExperiment } from '../experiments/useClientSideDPSellerIdExperiment';

import { useDocumentCaptureExperimentDecisions } from './useDocumentCaptureExperimentDecisions';

export const useMandatoryBankDetails = () => {
  const { isMandatoryBankDetailsEligible } = useDocumentCaptureExperimentDecisions();

  const optimizelyDecision = useClientSideDPSellerIdExperiment(
    FLAG.MANDATORY_BANK_DETAILS,
    isMandatoryBankDetailsEligible,
  );

  return optimizelyDecision;
};
